import { PersonDto } from 'dtos'
import { FedExShipmentDto } from 'dtos/fedEx'
import { MichiganOutgoingTitleVehicleDto } from './MichiganOutgoingTitleVehicleDto'

export class MichiganOutgoingTitleDto {
  michiganOutgoingTitleGuid?: string = undefined
  isLocked?: boolean = false
  vehicles?: MichiganOutgoingTitleVehicleDto[] = undefined
  fedExShipment?: FedExShipmentDto = undefined
  createdByPerson?: PersonDto = undefined
  createdDateTime?: string = undefined
  updatedByPerson?: PersonDto = undefined
  updatedDateTime?: string = undefined
}
